import { normalizeSearchString } from './normalizeSearchString'

export const prioritizeExactMatches = (bankName: string, searchQuery: string): number => {
  const query = normalizeSearchString(searchQuery)
  const name = normalizeSearchString(bankName)

  // Query is an exact match
  if (name === query) {
    return 0
  }

  // Query is at the start of the name
  if (name.startsWith(query)) {
    return 1
  }

  // Query is in the middle of the name
  if (name.includes(query)) {
    return 2
  }

  return 3
}
